import { get } from "lodash";

const getProtocol = () => (get(global, "appConf", false) ? "https:" : "");

export default getProtocol;
